import React from 'react';
import usePushNotifications from './usePushNotifications';
import { OffIcon, OnIcon } from './UIControls';

import * as styles from './PushNotification.module.scss';

export const PushNotification = props => {
	const { isPushNotificationSupported, userSubscription, onClickSusbribeToPushNotification, onClickUnsubscribeFromPushServer } = usePushNotifications(props);
	return (
		isPushNotificationSupported() &&
		!userSubscription && (
			<div>
				{userSubscription ? <OnIcon className={styles.fab} onClick={onClickUnsubscribeFromPushServer} /> : <OffIcon className={styles.fab} onClick={onClickSusbribeToPushNotification} />}
			</div>
		)
	);
};
